import './src/styles/global.css'

function showEmoji(emoji) {
  if (emoji) {
    emoji.style.display = 'block'
  }
}

const onInitialClientRender = () => {
  showEmoji(document.getElementById('emoji'))
}

export { onInitialClientRender }

export { wrapRootElement } from './wrapRootElement'
